module.exports = __webpack_public_path__ + "static/media/national.e5c1aede.svg";